var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      class: ["mi-vant-input", _vm.error ? "mi-vant-input-error" : ""],
      attrs: { disabled: _vm.disabled, placeholder: _vm.placeholder },
      domProps: { value: _vm.value },
      on: { input: _vm.inputMsg, blur: _vm.inputBlur }
    }),
    _vm._v(" "),
    _vm.error
      ? _c("p", { staticClass: "mi-vant-input-error-msg" }, [
          _vm._v(_vm._s(_vm.errorMsg))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Input/index.vue?vue&type=template&id=4dedd466&
// module id = null
// module chunks = 